/*
 * Created on Sat Feb 08 2020
 *
 * Copyright (c) 2020 Vilten,s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Viliam Tencer <vilten@vilten.sk>, Sat Feb 08 2020
 */
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vue2TouchEvents from 'vue2-touch-events'
import FlagIcon from 'vue-flag-icon'
import i18n from './i18n'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(Vue2TouchEvents)
Vue.use(FlagIcon)
Vue.use(VueCookies)

Vue.prototype.changeLocale = function (locale) {
  const resultLocale = locale === 'gb' ? 'en' : locale
  i18n.locale = resultLocale
  Vue.$cookies.set('locale', resultLocale)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
